import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { Messages } from '~src/codegen/Localize';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import {CardTitle} from '~src/spacesPlatform/components/card/CardTitle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { ContentTooltipProps } from '~src/spacesPlatform/components/tooltip/TooltipHelper';

import { LensTooltip } from '../tooltips/LensTooltip';
import { LensThumbnail } from './LensThumbnail';

export class LensCard extends ContentCard {

  public render() {
    const { content, hovered, selected, urls, addContentFavorite, removeContentFavorite } = this.props;
    return (
      <div className={CardViewStyles.Card}>
        <LensThumbnail
          hovered={hovered}
          selected={selected}
          navigateUrl={getContentUrlForItem(content, urls)}
          owner={content.owner}
          urls={urls}
          aria-label={content.name}
        />
        <div className={CardViewStyles.ActionRow}>
          <CardTitle name={content.name} />
          <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.lensTooltipTitle()}
            />
          </span>
          {FeatureFlags.askDataLensFavoritingEnabled && <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={content.favorite}
              onAddFavorite={() => addContentFavorite({ ...content, contentType: 'lens' })}
              onRemoveFavorite={() => removeContentFavorite({ ...content, contentType: 'lens' })}
            />
          </span>}
          {this.renderActionsMenu()}
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  protected getPopoverComponent(): React.ComponentType<ContentTooltipProps> {
    return LensTooltip;
  }
}
